import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "column-wide-half-remove" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M1.66699 8V13L8.33366 13M1.66699 8V3H14.3337V8H1.66699ZM11.0003 11L12.667 12.6667M12.667 12.6667L14.3337 14.3333M12.667 12.6667L11.0003 14.3333M12.667 12.6667L14.3337 11",
        stroke: "#7F7F83",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }